import { useMemo } from 'react';
import { useInfiniteQuery } from 'react-query';
import { AccountCacheKeys } from 'types/cacheKeys.types';
import { getAccountantReceivedInvitationsPage } from 'api/v3/access/accountantsAuth';

/**
 * Hook to fetch pending accountant invitations from customers
 */
export const useReceivedAccountantInvitations = () => {
  const query = useInfiniteQuery<any>(
    [AccountCacheKeys.ReceivedAccountantInvitations],
    ({ pageParam = 1 }) => getAccountantReceivedInvitationsPage(pageParam),
    {
      getNextPageParam: (lastPage) => {
        const { paging } = lastPage;
        if (paging && paging.page < paging.total_pages) {
          return paging.page + 1;
        }
        return undefined;
      },
    },
  );

  const { data, fetchNextPage, isFetching } = query;

  const flattenData = useMemo(
    () => data?.pages.flatMap((page) => page.invitations || []),
    [data],
  );

  const loadMore = (): void => {
    if (!isFetching) {
      fetchNextPage();
    }
  };

  return {
    ...query,
    totalCount: data?.pages[0]?.paging?.total_count,
    data: flattenData ?? [],
    loadMore,
  };
};
